module.exports = __webpack_public_path__ + "static/media/notificationNav.b5b82528.svg";